import axios from "axios";

// REACT_APP_API_URL already includes the trailing /api (see .env), same convention
// used elsewhere in this app (StudentLogin.jsx, useApiData.js).
const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api";

export const STATIC_ORIGIN = BASE_URL.replace(/\/api\/?$/, "");

// const adminApi = axios.create({
//   baseURL: BASE_URL,
//   withCredentials: true, // required so the admin captcha session cookie is sent/received
// });

const adminApi = axios.create({
  baseURL: BASE_URL,
});

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("mkcg_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default adminApi;
